export * from './polls-add/polls-add.component';
export * from './polls-edit/polls-edit.component';
export * from './polls-list/polls-list.component';
